import { HttpContext } from "@angular/common/http";
import { SKIP_SPINNER } from "../../../core/interceptors/spinner.interceptor";

export function skipSpinnerOptions() {
  return {
    context: new HttpContext().set(SKIP_SPINNER, false)
  };
}
